import {
	connect
} from 'react-redux'
import OrderViewComponent from '../components/OrderViewComponent.jsx';
import {
	findAllCustomerIds
} from '../actions';

function showNote(roles) {
	return roles.includes("ROLE_FIREFIGHTER_ORDER_CRUD");
}

const mapStateToProps = (state) => ({
	order: state.getIn(['orderReducer', 'order']),
	orderValidation: state.getIn(['orderReducer', 'orderValidation']),
	showNote: showNote(state.getIn(['authReducer', 'roles']).toJS())
})

const mapDispatchToProps = (dispatch) => ({
	findAllCustomerIds: () => {
		dispatch(findAllCustomerIds());
	}
})

const OrderViewContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(OrderViewComponent)

export default OrderViewContainer;


// WEBPACK FOOTER //
// ./src/containers/OrderViewContainer.jsx